import { UIHeading2 } from '@cian/ui-kit/typography';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

export interface ISeoHeadingProps {
  title: string;
  className?: string;
}

export const SeoHeading: React.FC<ISeoHeadingProps> = ({ title, className }) => {
  return (
    <div className={cn(styles['root'], className)}>
      <UIHeading2 as="h1">{title}</UIHeading2>
    </div>
  );
};

SeoHeading.displayName = 'SeoHeading';
